module.exports = __webpack_public_path__ + "media/images/massage/main_image1@2x-cc3206084126cfca45f98f0eb70ae5cc.jpg";